import { GET_ALL_EMPLOYEE_CLAIMS_LIST_SUCCESS, GET_ALL_EMPLOYEE_CLAIMS_LIST_FAIL } from "../actions";

const initialState = {
   hrclaims: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_EMPLOYEE_CLAIMS_LIST_SUCCESS:
      return Object.assign({}, state, { hrclaims: action.payload.data.hrclaims });
    case GET_ALL_EMPLOYEE_CLAIMS_LIST_FAIL:
      return Object.assign({}, state, { hrclaims: [] });
    default:
      return state;
  }
}
